import { render, staticRenderFns } from "./ProjectAuditLogsCompact.vue?vue&type=template&id=412fc03c&scoped=true&"
import script from "./ProjectAuditLogsCompact.vue?vue&type=script&lang=js&"
export * from "./ProjectAuditLogsCompact.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAuditLogsCompact.vue?vue&type=style&index=0&id=412fc03c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412fc03c",
  null
  
)

export default component.exports